/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Rollup_RowsInputs */



/**
* | output |
* | --- |
* | "Roll-up rows" |
*
* @param {Live_Caption_Rollup_RowsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_rollup_rows = /** @type {((inputs?: Live_Caption_Rollup_RowsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Rollup_RowsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rangées enroulées")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aufrollbare Reihen")
	if (locale === "it") return /** @type {LocalizedString} */ ("file arrotolabili")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Свернутые ряды")
	if (locale === "es") return /** @type {LocalizedString} */ ("Filas enrollables")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("卷起行")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ロールアップ列")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रोल-अप पंक्तियाँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("fileiras de enrolar")
	return /** @type {LocalizedString} */ ("Roll-up rows")
});